
import { QuickEmailProps } from '../types/quickemail.types';
import api from './api';

export async function handleVerifyEmail(email:string) {
    const res = await api.get<QuickEmailProps.Response>(`/Checks/VerifyEmail`,{
        params: {
            email
        }
    });

    return res.data;
}
